module.exports = __webpack_public_path__ + "img/image3.af153f05.png";